import { render } from "./TicketHistory.vue?vue&type=template&id=17cd1580"
import script from "./TicketHistory.vue?vue&type=script&lang=js"
export * from "./TicketHistory.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__